import AssignTviConnectInfo from './AssignTviConnectInfo'

export default AssignTviConnectInfo
